import { wait } from "../../utils/mock";

export const mockInvoice = {
    id: "uuid-1",
    name: "Faktura Fidoo 05/2024",
    transactionTypeId: "uuid-type-1",
    transactionTypeName: "Faktura",
    direction: "INCOME",
    idNumber: "202405001",

    hasCpty: true,
    counterpartyLabel: "Odběratel",
    hasSubjectInfo: true,
    subjectLabel: "Dodavatel",
    hasItems: true,
    hasTax: true,
    hasIdentificator: true,
    identificatorLabel: "Číslo faktury",
    hasDueDate: true,
    defaultDueDateDays: 20,
    hasPaymentInstructions: true,
    hasProjectReference: true,
    hasEmployeeReference: false,
    affectsTaxBasis: true,
    hasStatus: true,
    printable: true,
    currencyId: "uuid1234",
    paymentMethods: [
        {
            id: "uuid2",
            name: "Airbank CZK účet",
            type: "Bankovní převod",
            fields: [
                { label: "Číslo účtu", source: "CUSTOM", value: "1135914015" },
                { label: "Kód banky", source: "CUSTOM", value: "3030" },
                {
                    label: "Variabilní symbol",
                    source: "TRANSACTION",
                    value: "idNumber",
                },
            ],
            qrCode: [{}, {}],
        },
    ],
    printTemplateName: "Faktura",
    printTemplateCode: "invoice",

    date: "2024-05-31",
    dueDate: "2024-06-20",
    fiscalYear: 2024,
    currencyCode: "CZK",
    amount: 199500,
    totalPayable: 241395,
    subjectName: "Jan Hrabal",
    subjectAddress: "Karlovo náměstí 123, Praha 2",
    subjectIdNumber: "123456789",
    subjectTaxIdNumber: "CZ123456789",
    cptyId: "uuid-cpty-1",
    cptyName: "Fidoo s.r.o.",
    cptyAddress: "Karlovo náměstí 123, Praha 2",
    cptyIdNumber: "987654321",
    cptyTaxIdNumber: "CZ987654321",
    items: [
        {
            id: "uuid-item-1",
            name: "Licence Fidoo",
            units: 21,
            uom: "MD",
            unitPrice: 9500,
            total: 199500,
            taxItems: [
                {
                    id: "uuid-tax-item-1",
                    taxTypeId: "uuid1",
                    taxTypeName: "DPH 21%",
                    name: "DPH 21%",
                    percentage: 21.0,
                    base: 199500,
                    total: 41895,
                },
            ],
        },
    ],
    taxItems: [],
};

export const mockExpense = {
    transactionTypeId: "uuid2",
    transactionTypeName: "Náklad",
    direction: "EXPENDITURE",
    hasCpty: true,
    counterpartyLabel: "Dodavatel",
    hasIdentificator: true,
    identificatorLabel: "Číslo dokladu",
    hasTax: true,
    hasProjectReference: true,
    affectsTaxBasis: true,

    id: "uuid-2",
    name: "Nákup Alza.cz",
    idNumber: "234679",
    date: "2024-05-20",
    fiscalYear: 2024,
    currencyCode: "CZK",
    amount: 6800,

    cptyId: "uuid-cpty-1",
    cptyName: "Alza a.s.",
    cptyAddress: "Karlovo náměstí 123, Praha 2",
    cptyIdNumber: "987654321",
    cptyTaxIdNumber: "CZ987654321",

    taxItems: [
        {
            id: "uuid-tax-item-1",
            taxTypeId: "uuid1",
            taxTypeName: "DPH 21%",
            percentage: 21.0,
            name: "DPH 21%",
            base: 6800,
            total: 1428,
        },
    ],
};

export const fetchTransactionList = async (filter) => {
    console.log("fetching transactions", filter);
    await wait(2450);
    const items = [];
    for (let i = 0; i < 48; i++) {
        items.push({ ...mockInvoice, id: `invoice-${i}` });
        items.push({ ...mockExpense, id: `expense-${i}` });
    }

    return {
        isFirst: true,
        hasMore: false,
        items,
    };
};

export const fetchTransactionOverview = async ({ filter }) => {
    console.log("fetching overview", filter);
    await wait(1234);
    return {
        currencyCode: "CZK",
        totals: {
            currencyCode: "CZK",
            balance: {
                current: 1789000,
                previous: 1600000,
                diffPercent: 12,
            },
            income: {
                current: 2200000,
                previous: 1900000,
                diffPercent: 9,
            },
            expenditure: {
                current: 580000,
                previous: 500000,
                diffPercent: 16,
            },
        },
        cashflow: {
            currencyCode: "CZK",
            data: [
                {
                    name: "M-2023-01",
                    values: {
                        uuid1: 12000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 105900,
                    },
                },
                {
                    name: "M-2023-02",
                    values: {
                        uuid1: -184000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-03",
                    values: {
                        uuid1: 205000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 305900,
                    },
                },
                {
                    name: "M-2023-04",
                    values: {
                        uuid1: 184000,
                        uuid2: 3200,
                        uuid0: 75000,
                        uuid3: 87000,
                        uuid5: 39000,
                    },
                },
                {
                    name: "M-2023-05",
                    values: {
                        uuid1: 192000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-06",
                    values: {
                        uuid1: 184000,
                        uuid2: 2400,
                        uuid0: 35000,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-07",
                    values: {
                        uuid1: 192000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-08",
                    values: {
                        uuid1: 184000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-09",
                    values: {
                        uuid1: 205000,
                        uuid2: 3200,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-10",
                    values: {
                        uuid1: 220000,
                        uuid2: 3200,
                        uuid0: 11000,
                        uuid3: 6000,
                        uuid5: 39000,
                    },
                },
                {
                    name: "M-2023-11",
                    values: {
                        uuid1: 192000,
                        uuid2: 6500,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
                {
                    name: "M-2023-12",
                    values: {
                        uuid1: 184000,
                        uuid2: 2400,
                        uuid0: 35000,
                        uuid3: 12000,
                        uuid5: 5900,
                    },
                },
            ],
        },
        transactionTypes: [
            {
                id: "uuid1",
                name: "Faktura",
                direction: "INCOME",
                amount: 2340000,
            },
            {
                id: "uuid2",
                name: "Náklad",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid20",
                name: "Výplata zaměstnanci",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid0",
                name: "Daň z příjmu",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid3",
                name: "Sociální pojištění",
                direction: "EXPENDITURE",
                amount: 439000,
            },
            {
                id: "uuid5",
                name: "Zdravotní pojištění",
                direction: "EXPENDITURE",
                amount: 439000,
            },
        ],
    };
};

export const fetchTransactionDetail = async (id) => {
    console.log("fetching detail", id);
    const [type] = id.split("-");
    await wait(1234);
    switch (type) {
        case "invoice":
            return { ...mockInvoice, id };
        case "expense":
            return { ...mockExpense, id };
        default:
            return { id };
    }
};

export const saveTransaction = async (data) => {
    await wait(3402);
};
